import { render, staticRenderFns } from "./ObrasIndex.vue?vue&type=template&id=5ceedc58&"
import script from "./ObrasIndex.vue?vue&type=script&lang=js&"
export * from "./ObrasIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports